$(document).ready(function () {
  createHTWCheckboxes();

  makeCheckboxChecked('audience%5B%5D', 'Stelle für');
  makeCheckboxChecked('suitsTo%5B%5D', 'Eignet sich für');
  makeCheckboxChecked('internship', 'Praktikumsstellen');

  /**
   * Get the GET parameter values as array
   */
  let selectedCheckboxesAudience = getQueryParameter('audience%5B%5D');
  let selectedCheckboxesSuitsTo = getQueryParameter('suitsTo%5B%5D');
  let selectedCheckboxInternship = getQueryParameter('internship');

  /**
   * When a checkbox from 'Stelle für' is clicked, push value of checkbox into array
   */
  $("input[group='Stelle für']").change(function () {
    if ($.inArray($(this).val(), selectedCheckboxesAudience) <= -1) {
      selectedCheckboxesAudience.push($(this).val());
    } else {
      selectedCheckboxesAudience.splice(
        selectedCheckboxesAudience.indexOf($(this).val()),
        1
      );
    }
  });

  /**
   * When a checkbox from 'Eignet sich für' is clicked, push value of checkbox into array
   */
  $("input[group='Eignet sich für']").change(function () {
    if ($.inArray($(this).val(), selectedCheckboxesSuitsTo) <= -1) {
      selectedCheckboxesSuitsTo.push($(this).val());
    } else {
      selectedCheckboxesSuitsTo.splice(
        selectedCheckboxesSuitsTo.indexOf($(this).val()),
        1
      );
    }
  });

  /**
   * When a checkbox from 'Praktikumsstellen' is clicked, push value of checkbox into array
   */
  $("input[group='Praktikumsstellen']").change(function () {
    if ($.inArray($(this).val(), selectedCheckboxInternship) <= -1) {
      selectedCheckboxInternship.push($(this).val());
    } else {
      selectedCheckboxInternship.splice(
        selectedCheckboxInternship.indexOf($(this).val()),
        1
      );
    }
  });

  /**
   * Search jobs with filter options
   */
  $('#searchJob').click(function () {
    document.location.href = insertJobParams(
      'audience[]',
      selectedCheckboxesAudience,
      'suitsTo[]',
      selectedCheckboxesSuitsTo,
      'internship',
      selectedCheckboxInternship
    );
  });
});

/**
 * Get the key GET parameters and change every checkbox to checked which has the groupName value.
 * @param key
 * @param groupName
 */
function makeCheckboxChecked(key, groupName) {
  let keysAndValues = getQueryParameter(key);
  $.each($("input[group='" + groupName + "']"), function (index, element) {
    if ($.inArray(decodeURI($(element).prop('value')), keysAndValues) !== -1) {
      $(element).prop('checked', true);
    }
  });
}

/**
 * Insert selected key and values to GET parameters when they don't exist, otherwise change them.
 * Works with arrays because job filters contain multiple checkboxes.
 * @param audienceKey
 * @param audienceValues
 * @param suitsToKey
 * @param suitsToValues
 * @param internshipKey
 * @param internshipValue
 */
function insertJobParams(
  audienceKey,
  audienceValues,
  suitsToKey,
  suitsToValues,
  internshipKey,
  internshipValue
) {
  let url = new URL(window.location.href);
  let params = new URLSearchParams(url.search.slice(1));

  params.delete(audienceKey);
  params.delete(suitsToKey);
  params.delete(internshipKey);

  $.each(audienceValues, function (index, element) {
    params.append(audienceKey, element);
  });

  $.each(suitsToValues, function (index, element) {
    params.append(suitsToKey, element);
  });

  if (internshipValue.length > 0) {
    params.append(internshipKey, internshipValue);
  }

  return (
    window.location.origin + window.location.pathname + '?' + params.toString()
  );
}

/**
 * Search for key occurrences in GET parameters and return array with all matching values.
 * @returns {Array}
 */
function getQueryParameter(key) {
  let result = [];
  let queryString = document.location.search;
  let matches = '';
  let regExp = new RegExp(key + '=([A-z0-9%]+)&?', 'g');

  while (matches !== null) {
    matches = regExp.exec(queryString);

    if (matches !== null) {
      result.push(decodeURI(matches[1]));
    }
  }
  return result;
}

/**
 * Manipulate checkboxes to show them with the HTW-Design
 */
function createHTWCheckboxes() {
  let inputs = $('form[id^="jobexchange"]').find('input[type="checkbox"]');
  let divs = $('form[id^="jobexchange"]').find('.form-check');

  $.each(inputs, function (index) {
    console.log($(inputs[index]));
    if (!$(inputs[index]).hasClass('mdc-checkbox__native-control')) {
      $(inputs[index]).addClass('mdc-checkbox__native-control');
      $(inputs[index]).after(
        '<div class="mdc-checkbox__background">\n' +
          '<div class="mdc-checkbox__inner-box"></div>\n' +
          '</div>'
      );
    }
  });

  $.each(divs, function (index) {
    $(divs[index]).addClass('mdc-checkbox');
  });
}
